import isNil from 'lodash/isNil'
import { MouseEvent } from 'react'

import AnalyticsService from '../../../services/analytics-service'
import { FilterItemTransport } from '../../../transports/filters-configuration-transport'
import { FilterType } from './types'
import { trackingClient } from '../../../clients'
import { searchResultListingsPageEventActions } from '../../../services/analytics-service/actions'
import { searchResultListingsPageEventCategories } from '../../../services/analytics-service/categories'
import { searchResultListingsPageEventLabels } from '../../../services/analytics-service/labels'
import { searchResultListingsPageEvents } from '../../../services/analytics-service/events'
import { SITE_NAME } from '../../../common/constants'

export const preventEvent = (event: Event | MouseEvent<HTMLElement>) => {
    event.preventDefault()
    event.stopPropagation()
}

export const checkPriceFilterValidity = (filterItem: FilterItemTransport) => {
    return !isNil(filterItem.minPrice) && !isNil(filterItem.maxPrice)
}

interface FilterGATrackingProps {
    type: FilterType
    name: string
    value: number
    isChecked?: boolean
    payload?: any
    regionNodeId: number
}

export const filterGATracking = ({ type, name, value, isChecked, payload, regionNodeId }: FilterGATrackingProps) => {
    const action = searchResultListingsPageEventActions.filterSection.FILTER_CLICK
    const category = searchResultListingsPageEventCategories.filterSection.FILTER_CLICK + SITE_NAME.SRL_PAGE_MAP_VIEW
    let label: string
    switch (type) {
        case FilterType.PRICES: {
            label =
                searchResultListingsPageEventLabels.filterSection.filterClick.priceFilter.START_PRICE +
                payload.startPrice +
                searchResultListingsPageEventLabels.filterSection.filterClick.priceFilter.END_PRICE +
                payload.endPrice
            AnalyticsService.trackEvent({ action, category, label })
            break
        }
        case FilterType.CANCELLATION_POLICY: {
            label =
                searchResultListingsPageEventLabels.filterSection.filterClick.cancellationPolicyFilter.START_LABEL +
                isChecked
                    ? searchResultListingsPageEventLabels.filterSection.filterState.CHECK
                    : searchResultListingsPageEventLabels.filterSection.filterState.UNCHECK
            AnalyticsService.trackEvent({ action, category, label })
            break
        }
        case FilterType.BEDROOMS:
        case FilterType.BOOKING_TYPES:
        case FilterType.FEATS:
        case FilterType.OFFERS:
        case FilterType.PROPERTY_TYPES:
        case FilterType.STARS:
        case FilterType.SUITED:
        case FilterType.TOPICS:
        default: {
            label = `${type} + - + ${name}`
            const checkboxStatus = isChecked
                ? searchResultListingsPageEventLabels.filterSection.filterState.CHECK
                : searchResultListingsPageEventLabels.filterSection.filterState.UNCHECK

            AnalyticsService.trackEvent(
                {
                    action,
                    category,
                    label,
                    ga_custom_param_checkbox_status: checkboxStatus,
                    page_name: SITE_NAME.SRL_PAGE_MAP_VIEW,
                },
                false,
            )
            break
        }
    }

    AnalyticsService.trackEvent({
        event: searchResultListingsPageEvents.filterSection.CLICK_RESULT_FILTER,
        eventValue: `${type} - ${name}`,
    })

    if (!!regionNodeId && isChecked) {
        trackingClient
            .trackFilterRegionNode(regionNodeId.toString(), [
                {
                    filterName: name,
                    filterType: type,
                    filterId: value,
                },
            ])
            .then()
    }
}
